module.exports = __webpack_public_path__ + "fonts/Prompt-SemiBoldItalic.ba8ac934.ttf";